<template>
  <div class="expresses">
    <a-scroll-table class="table"
                    :autoScroll="true"
                    :pagination="false"
                    :data-source="expresses"
                    :loading="isLoading">
      <a-table-column title=""
                      width="150px">
        <template #default="{ record }">
          <div class="logo">
            <img :src="record.company.logo"
                 :alt="record.company.name" />
          </div>
        </template>
      </a-table-column>
      <a-table-column :title="$t('financial.ExpressRate.expressName')"
                      width="150px"
                      data-index="name"></a-table-column>
      <a-table-column :title="$t('financial.ExpressRate.expressAddress')"
                      width="150px"
                      data-index="province"></a-table-column>
      <a-table-column :title="$t('financial.ExpressRate.priceDetail')"
                      min-width="350px">
        <template #default="{ record }">
          <div class="rates">
            <div class="title">
              <span class="province">{{ $t('financial.ExpressRate.province') }}/{{ $t('financial.ExpressRate.city') }}</span>
              <span class="init-weight">{{ $t('financial.ExpressRate.initWeight') }}</span>
              <span class="init-rate">{{ $t('financial.ExpressRate.initRate') }}</span>
              <span class="addition-rate">{{ $t('financial.ExpressRate.additionRate') }}</span>
            </div>
            <div v-for="(item, index) in record.grouped_rates"
                 :key="index"
                 class="rate">
              <span class="destinations">
                <span v-for="(province, dIndex) in item.destinations || []"
                      :key="dIndex">
                  {{ province }}
                  <span v-if="item.destinations.length - 1 != dIndex">、</span>
                </span>
              </span>
              <span class="init-weight">{{ item.rate.init_weight }}kg</span>
              <span class="init-rate">￥{{ Number(item.rate.init_rate).toFixed(2) }}</span>
              <span class="addition-rate">￥{{ Number(item.rate.addition_rate).toFixed(2) }}</span>
            </div>
          </div>
        </template>
      </a-table-column>
    </a-scroll-table>
  </div>
</template>

<script lang="ts" setup>
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CORE_AXIOS, Http } from '@/core'
import { container } from 'tsyringe'
import { onMounted, ref } from 'vue'
import { AScrollTable } from '@iota-cn/ui-components'

// 查询快递及价格清单
const fetchExpressList = async (): Promise<any> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get('/v1/api/pdm/express/sub_companies')
}

const isLoading = ref(true)
const expresses = ref([])

onMounted(() => {
  fetchExpressList().then((res) => {
    expresses.value = res.companies.map((c: any) => {
      const grouped_rates: any = {}
      c.rates.sort((a: any, b: any) => { return a.addition_rate - b.addition_rate })
      c.rates.forEach((r: any) => {
        const key = `${r.init_weight}/${r.init_rate}/${r.addition_rate}`
        const g = grouped_rates[key] = grouped_rates[key] || {
          rate: {
            init_weight: r.init_weight,
            init_rate: r.init_rate,
            addition_rate: r.addition_rate
          }, destinations: []
        }
        g.destinations.push(r.destination)
      })
      c.grouped_rates = Object.values(grouped_rates)
      return c
    })
    isLoading.value = false
  })
})
</script>

<style lang="less" scoped>
.expresses {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .table {
    height: 100%;
    padding: 24px 24px;

    .logo {
      width: 100px;
      height: 50px;
      position: relative;
      text-align: center;
      margin: 0 auto;

      img {
        max-width: 100%;
        max-height: 100%;
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
      }
    }

    .rates {
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-all;
      line-height: 23px;
      padding-right: 10px;

      .title {
        display: flex;
        font-weight: bold;
        padding: 5px 0;

        .province {
          min-width: 130px;
          flex: 1;
          text-align: left;
        }

        .init-weight,
        .init-rate,
        .addition-rate {
          width: 70px;
        }
      }

      .rate {
        display: flex;
        border-bottom: 1px solid #eeeeee;

        .destinations {
          min-width: 130px;
          flex: 1;
          padding: 5px 0;
          display: flex;
          flex-wrap: wrap;
        }

        .init-weight,
        .init-rate,
        .addition-rate {
          width: 70px;
          display: flex;
          justify-content: center;
          align-items: center
        }
      }
    }
  }
}
</style>